import VanTableInterface from '@/utilities/bid/cost/Interfaces/VanTableInterface'
import VanCollectionInterface from '@/utilities/bid/cost/Interfaces/VanCollectionInterface'
import ShiftCollectionInterface from '@/utilities/bid/cost/Interfaces/ShiftCollectionInterface'
import TotalCollectionInterface from '@/utilities/bid/cost/Interfaces/TotalCollectionInterface'
import CollectionInterface from '@/utilities/bid/cost/Interfaces/CollectionInterface'
import RoundNumber from '@/utilities/helper/RoundNumber'

class VanTable implements VanTableInterface {
  labour: Array<CollectionInterface>
  shifts: Array<ShiftCollectionInterface>
  totals: Array<TotalCollectionInterface>

  constructor(labour: Array<CollectionInterface>, shifts: Array<ShiftCollectionInterface>, totals: Array<TotalCollectionInterface>) {
    this.labour = labour
    this.shifts = shifts
    this.totals = totals
  }

  getAll(): Array<VanCollectionInterface> {
    const totalFee = this.totals.find(item => {
      return item.ref === 'fee'
    })

    const feeValue = new RoundNumber().roundTo(totalFee?.value)
    const sumOfDuration = this.getSumOfSiteWorkDuration(this.labour)

    return [
      { title: 'Actual', key: 'actual', value: this.getActual(feeValue, this.shifts) },
      { title: 'Re-based', key: 'rebased', value: this.getRebased(feeValue, sumOfDuration) },
    ]
  }

  getActual(totalFee: number = 0, shifts: Array<ShiftCollectionInterface>): number {
    let sumOfShifts: number = 0
    shifts.forEach((element: ShiftCollectionInterface) => {
      sumOfShifts += element.count
    })
    return totalFee / sumOfShifts
  }

  getRebased(totalFee: number = 0, duration: number = 0): number {
    return totalFee / (duration / 9.5)
  }

  getSumOfSiteWorkDuration(labour: Array<CollectionInterface>): number {
    let sumOfDuration: number = 0
    labour.forEach((element: CollectionInterface) => {
      sumOfDuration += /^siteworks_\w+/.test(element.key) ? element.calculated : 0
    })
    return sumOfDuration
  }
}

export default VanTable
